
import CaseStudy, { CASE_STUDY_TYPES } from '../../../components/case-study/CaseStudy';
import Header from '../../../components/Header';
import Layout from '../../../components/Layout';
import ThumbnailImage from '../../../images/thumbnails/IDC.png';

export function Index() {
  return (
    <Layout 
    title="How IDC used photos, posters and avatars to drive social sharing"
    description="IDC (International Data Corporation) is a global powerhouse in market intelligence, advisory services, and events. Every year, they host multiple high-profile events across APAC, India, the Middle East, and South Africa, bringing together some of the brightest minds in the industry."
    metaImage={ThumbnailImage}
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.idc} />
    </Layout>
  );
}

export default Index;